import matchList from '@gin-betting/match-list';

import { TOP_MARKETS_TYPE, TOP_MARKETS_TYPE_MAPPING } from 'app-constants';
import { topMarketsVerify } from 'utils';
import MarketDefault from './components/SportEventRow/Markets/MarketDefault';
import MarketHcp from './components/SportEventRow/Markets/MarketHcp';
import MarketTotal from './components/SportEventRow/Markets/MarketTotal';

const {
    utils: { makeMarketComponent },
} = matchList;
const { isDefault, isHCP, isTotal } = topMarketsVerify;

const MarketDefaultContainer = makeMarketComponent({
    condition: isDefault,
    Component: MarketDefault,
});

/* TODO don`t use any */
const MarketHcpContainer = makeMarketComponent({
    condition: isHCP,
    Component: MarketHcp,
});

const MarketTotalContainer = makeMarketComponent({
    condition: isTotal,
    Component: MarketTotal,
});

export function getTopMarketComponentsBySport(
    sportId: string,
    options: {
        count: number;
    }
) {
    // TODO: Change to returning strings
    const { count } = options;

    const topMarketTypeForSport =
        TOP_MARKETS_TYPE_MAPPING[
            sportId as keyof typeof TOP_MARKETS_TYPE_MAPPING
        ];

    if (
        !topMarketTypeForSport ||
        topMarketTypeForSport === TOP_MARKETS_TYPE.SINGLE
    )
        return [MarketDefaultContainer];

    switch (count) {
        case 1: {
            return [MarketDefaultContainer];
        }

        case 2: {
            return [MarketDefaultContainer, MarketTotalContainer];
        }

        default: {
            return [
                MarketDefaultContainer,
                MarketHcpContainer,
                MarketTotalContainer,
            ];
        }
    }
}
